import { useState, useEffect } from "react";
import axios from "axios";
import { switchEndpoint } from "../../../../../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../../../../../scopedStorage";

const toLabel = (name) =>
  name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const normaliseCategory = (cat) => ({
  id: cat.uid,           // uid is unique across all categories
  label: toLabel(cat.name),
  pricingKey: cat.name,  // original snake_case name, sent in the transaction payload
  pricePerKg: cat.pricing_per_kg,
});

const useFetchCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const token = storage.getItem("token");
        const response = await axios.get(
          `${switchEndpoint}/group-waste-categories`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // console.log(response.data)
        const normalised = (response.data || [])
          .filter((cat) => cat.dropoff_active === true)
          .map(normaliseCategory);
        setCategories(normalised);
        // console.log(normalised)
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};

export default useFetchCategories;
